import React from 'react';
import Header from 'components/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FAQsData from 'data/FAQs';
import Accordion from 'components/Accordion';

export default function FAQs() {
  return (
    <div className="">
      <Header />
      <main className="main aboutPage">
        <section className="section" aria-label="About Intro Section">
          <div className="section-intro">
            <h2>About page</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum in
              consequuntur minus est sunt aperiam necessitatibus temporibus
              molestias doloribus. Dolore autem commodi praesentium, unde
              perspiciatis voluptatem illo, voluptas inventore amet dolor
              adipisci dicta qui sapiente animi rem vero sit. Quidem minima
              ipsum enim asperiores cum eveniet maiores iusto consectetur
              adipisci?
            </p>
          </div>
        </section>

        <section
          className="section accordion-section"
          aria-label="accordion-section"
        >
          <h2 className="section-title">
            Here are some common questions we get asked often:
          </h2>

          <div className="accordions">
            {FAQsData.map(({ title, body }) => (
              <Accordion key={title} title={title} body={body} />
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
